import { Grid } from '@mui/material';
import { FC } from 'react';
import AcademicsLessonPlansGridView from './academicsLessonPlansGrid.view';
import AddEditLessonPlanView from './addEditLessonPlan.view';

const AcademicsLessonPlansView: FC = () => {
  return (
    <Grid container spacing={{ xs: 1, sm: 2 }} data-testid="academics-lesson-plans-view">
      <Grid item xs={12}>
        <AcademicsLessonPlansGridView />
      </Grid>
      <AddEditLessonPlanView />
    </Grid>
  );
};

export default AcademicsLessonPlansView;
